import { Wrapper } from "shared/ui/Wrapper/Wrapper";
import { Button, ButtonTheme } from "shared/ui/Button/Button";
import { Text, TextSize } from "shared/ui/Text/Text";
import { ReactNode, useEffect, useState } from "react";
import { TransactionCards } from "entities/TransactionCards";
import { TransactionCardsTheme } from "entities/TransactionCards/TransactionCards";
import { useNavigate } from "react-router-dom";
import { useApi } from "app/api/APIProvider";
import { PageLoader } from "shared/ui/PageLoader/PageLoader";
import { ConditionCard } from "entities/ConditionCard/ConditionCard";
import { PolicyCard } from "entities/PolicyCard";
import { PolicyCardTheme } from "entities/PolicyCard/PolicyCard";
import { AppLink } from "shared/ui/AppLink/AppLink";
import Kit from "shared/assets/icons/Kit.svg";
import Pulse from "shared/assets/icons/Pulse.svg";
import Crown from "shared/assets/icons/Crown.svg";
import Logo from "shared/assets/img/sber_logo.png";
import plug from "shared/assets/img/pages/card-plug.png";
import PlayIcon from "shared/assets/icons/playIcon.svg";
import cls from "./NSGPage.module.scss";

interface INSJ {
    earnedAll: number;
    initialMoney: string;
    level: number;
    status: string;
    yearMoney: string;
}

export const NSGPage = () => {
    const api = useApi();
    const navigate = useNavigate();
    const [closedNSJ, setClosedNSJ] = useState<INSJ[]>([]);
    const [nsjData, setNsjData] = useState<any>([]);
    const [hasOpenedProducts, setHasOpenedProducts] = useState<boolean>(false);
    const [financeInfo, setFinanceInfo] = useState<any>({
        dms: { status: false },
        dsj: { status: false },
        investment: { status: false },
        nsj: { accumulated: "30000", contributionSum: 30000, status: true },
        osago: { status: false },
        property_insurance: { status: false },
        sjz: { status: true },
    });
    // const [openedNSJ, setOpenedNSJ] = useState<INSJ[]>([]);
    // const [conditions, setConditions] = useState([]);
    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const buttonsData = [
        {
            text: "Травма",
            icon: <Kit />,
        },
        {
            text: "Критические заболевания",
            icon: <Pulse />,
        },
        {
            text: "Дожитие до окончания договора страхования НСЖ",
            icon: <Crown />,
        },
    ];

    const banner = {
        name: "Пока у вас нет страховых продуктов",
        description: "Вы можете зайти в раздел мои финансы и приобрести их",
        img: plug,
        button: {
            text: "Мои финансы",
            url: "/finance",
        },
        cost: "",
        type: "banner",
    };

    const buttonData = { text: "В Мои финансы", url: "/finance" };

    const conditions = [
        {
            name: "Добровольное медицинское страхование",
            contributionSum: "15000",
            term: "1 год",
            status: financeInfo.dms.status,
            button: {
                url: "/finance/policy/dms",
            },
        },
        {
            name: "Накопительное страхование жизни (НСЖ)",
            contributionSum: financeInfo.nsj.contributionSum,
            accumulated: financeInfo.nsj.accumulated,
            status: financeInfo.nsj.status,
            button: {
                url: "/finance/policy/nsj",
            },
        },
        {
            name: "Страхование жизни и здоровья",
            contributionSum: "5000",
            term: "1 год",
            status: financeInfo.sjz.status,
            button: {
                url: "/finance/policy/sjz",
            },
        },
        {
            name: "ОСАГО",
            contributionSum: "7000",
            term: "1 год",
            status: financeInfo.osago.status,
            button: {
                url: "/finance/policy/osago",
            },
        },
        {
            name: "Страхование имущества и гражданской ответственности",
            contributionSum: "3500",
            term: "1 год",
            status: financeInfo.property_insurance.status,
            button: {
                url: "/finance/policy/property_insurance",
            },
        },
        {
            name: "Долевое страхование жизни",
            depositAmount: financeInfo.dsj.initialMoney,
            refillPerYear: financeInfo.dsj.refillPerYear,
            percentageRate: "12%",
            accumulated: financeInfo.dsj.earnedPercent,
            totalSum: financeInfo.dsj.earnedAll,
            status: financeInfo.dsj.status,
            button: {
                url: "/finance/policy/dsj",
            },
        },
    ];

    const getUserMoney = async () => {
        const { nsj } = await api.GetUserMoney("nsj");
        const res = await api.GetFinanceInfo();
        console.log(res, "res");
        // console.log(nsj, 'res');
        //@ts-ignore
        setFinanceInfo(res);
        //@ts-ignore
        setHasOpenedProducts(
            !![
                res.nsj,
                //@ts-ignore
                res.sjz,
                //@ts-ignore
                res.property_insurance,
                //@ts-ignore
                res.dms,
                res.osago,
                res.dsj,
            ].filter((value) => value.status).length
        );
        // setHasOpenedProducts(!!Object.entries(res).filter(([k, value]) => value.status).length);
        //@ts-ignore
        setClosedNSJ(nsj.filter((nsjCard: INSJ) => !nsjCard.status));
        setIsLoaded(true);
    };

    useEffect(() => {
        getUserMoney();
    }, []);

    if (!isLoaded) return <PageLoader />;
    return (
        <div className={cls.page}>
            <Wrapper className={cls.mainWrapper}>
                <main className={cls.main}>
                    {closedNSJ.length === 0 && !hasOpenedProducts ? (
                        <>
                            <Text
                                className={cls.title}
                                color="#353850"
                                size={TextSize.text_36}
                            >
                                Мои продукты
                            </Text>
                            <PolicyCard
                                banner={banner}
                                theme={PolicyCardTheme.banner}
                            />
                        </>
                    ) : (
                        <>
                            <div className={cls.accidentSection}>
                                <Text
                                    className={cls.title}
                                    color="#353850"
                                    size={TextSize.text_36}
                                >
                                    Вы можете застраховать
                                </Text>
                                <div className={cls.buttonsWrapper}>
                                    {buttonsData.map(
                                        (
                                            data: {
                                                text: string;
                                                icon: ReactNode;
                                            },
                                            index: number
                                        ) => {
                                            const { text, icon } = data;
                                            return (
                                                <Button
                                                    className={
                                                        cls.accidentButton
                                                    }
                                                    icon={icon}
                                                    theme={ButtonTheme.BACK}
                                                    key={index}
                                                >
                                                    {text}
                                                </Button>
                                            );
                                        }
                                    )}
                                </div>
                            </div>
                            {hasOpenedProducts && (
                                <div>
                                    <Text
                                        className={cls.title}
                                        color="#353850"
                                        size={TextSize.text_36}
                                    >
                                        Мои продукты
                                    </Text>
                                    <div className={cls.conditionsWrapper}>
                                        {conditions.map(
                                            (condition, index: number) => {
                                                if (condition.status === false)
                                                    return;
                                                return (
                                                    <ConditionCard
                                                        conditions={condition}
                                                        key={index}
                                                    />
                                                );
                                            }
                                        )}
                                    </div>
                                </div>
                            )}
                            {closedNSJ.length !== 0 && (
                                <div>
                                    <Text
                                        className={cls.title}
                                        color="#353850"
                                        size={TextSize.text_36}
                                    >
                                        История
                                    </Text>
                                    <div className={cls.cardsWrapper}>
                                        {closedNSJ.map((transaction, index) => {
                                            return (
                                                <TransactionCards
                                                    transaction={transaction}
                                                    theme={
                                                        TransactionCardsTheme.closed
                                                    }
                                                    showPercentage={false}
                                                    key={index}
                                                />
                                            );
                                        })}
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                </main>
                <AppLink to="/plot" className={cls.backToGameButton}>
                    <Button
                        theme={ButtonTheme.BACK_TO_GAME}
                        icon={<PlayIcon />}
                    >
                        Продолжить сюжет
                    </Button>
                </AppLink>
                <img className={cls.logo} src={Logo} alt="" />
            </Wrapper>
        </div>
    );
};
